import {
  IAction,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as Types from './types';

export interface IState {
  vatReturnRemindersList: any;
  vatReturnRemindersGenerateStatus: StateStatus | undefined;
}

const initialState: IState = {
  vatReturnRemindersList: {
    status: null,
    data: null,
  },
  vatReturnRemindersGenerateStatus: undefined,
};

const VatReturnRemindersReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_VATRETURN_REMINDERS_LIST:
      return {
        ...state,
        vatReturnRemindersList: {
          ...state.vatReturnRemindersList,
          status: action.status,
          data:
            action.data === KEEP_THE_SAME
              ? state.vatReturnRemindersList.data
              : action.data,
        },
      };
    case Types.SET_VATRETURN_REMINDERS_TO_GENERATE:
      return {
        ...state,
        vatReturnRemindersGenerateStatus: action.status,
      };
    default:
      return {
        ...state,
      };
  }
};

export default VatReturnRemindersReducer;
